<atlas-navbar
  [serviceProviderId]="serviceProviderId"
  [partnerId]="partnerId"
  [accountId]="accountId"
  [marketId]="marketId"
  [groupPath]="brandPath"
  [dropdownItems]="dropdownItems$ | async"
  [hideCenters]="hideCenters"
  [hideNotifications]="hideNotifications"
  [disableUserDropdown]="disableUserDropdown"
  (event)="propagateEvent($event)"
  [showLanguageSelector]="showLanguageSelector"
>
  <atlas-item
    *ngIf="showMenuHamburger$ | async"
    interactable
    icon="store"
    iconText="{{ 'MENU_TOGGLE' | translate }}"
    customClass="atlas-navbar__menu-toggle"
    (click)="toggleMenu()"
  ></atlas-item>
  <atlas-location-selector></atlas-location-selector>
  <div class="atlas-spacer"></div>
  <ng-content></ng-content>
</atlas-navbar>
<atlas-business-sidebar></atlas-business-sidebar>
<atlas-snackbar></atlas-snackbar>
